import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetScheduleJobCard = createModule({
  base: 'GET_SCHEDULE_JOB_CARD',
  apiDetails: SERVICE_ENDPOINT.GET_SCHEDULE_JOB_CARD,
  errors: { defaultError: false, customError: '' },
});

export { GetScheduleJobCard };